export default __webpack_public_path__ + "static/media/DPE_G.0bb03463.png";